export const clearStoragePreservingTours = () => {
  const keysToRemove: string[] = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && !key.startsWith('tour_seen_') && !key.startsWith('tour_modal_count') && key !== 'preferred_login_method') {
      keysToRemove.push(key);
    }
  }
  
  // Remove only non-tour keys
  keysToRemove.forEach(key => {
    localStorage.removeItem(key);
  });
  
  sessionStorage.clear();
};


export const savePreferredLoginMethod = (method: 'email' | 'mobile') => {
  localStorage.setItem('preferred_login_method', method);
};


export const getPreferredLoginMethod = (): 'email' | 'mobile' | null => {
  const method = localStorage.getItem('preferred_login_method');
  return method === 'email' || method === 'mobile' ? method : null;
};
